import * as filterAPI from '@apps-common/js-client/api/filter';
import * as itemsAPI from '@apps-common/js-client/api/items';
import {SOURCE_TYPES as SOURCES} from '@apps-common/location-search/util.js';
import kinda from 'kinda';

export const SOURCE_TYPES = {
  ...SOURCES,
  ITEM_IDS: 'itemIds',
  SAVED_SEARCHES: 'savedSearches',
};

/**
 * Generate a list of items whose identifiers match the given query.
 * @param {string} query A query string.
 * @return {Promise<Array>} A promise for a list of suggestions.
 */
export const suggestSearchItemIds = (query, itemTypes = []) => {
  let promise;
  if (itemTypes.length > 0 && query.length > 10 && query.indexOf(' ') === -1) {
    promise = itemsAPI
      .search({
        types: itemTypes,
        filter: filterAPI.strings('id', [query]),
      })
      .then(features => {
        return features.map(item => ({
          id: item.id,
          title: item.id,
          description: item.properties.item_type,
          source: SOURCE_TYPES.ITEM_IDS,
          searchItem: item,
        }));
      });
  } else {
    promise = Promise.resolve([]);
  }
  return promise;
};

/**
 * Generate a list of saved searches that match the given query.
 * @param {string} query A query string.
 * @return {Array} A list of any matching saved searches.
 */
export const suggestSavedSearches = (query, searches) => {
  const suggestions = [];
  // suggest any matching saved searches
  if (query.length > 3 && searches) {
    const ranked = searches
      .map(search => ({
        search: search,
        match: kinda(query, search.name),
      }))
      .sort((a, b) => (a.match > b.match ? 1 : -1));

    ranked.forEach(item => {
      if (item.match > 0.3) {
        suggestions.unshift({
          id: item.search.id,
          title: item.search.name,
          description: 'Saved search',
          source: SOURCE_TYPES.SAVED_SEARCHES,
          savedSearch: item.search,
          search: true,
        });
      }
    });
  }
  return suggestions;
};
